import { Nullable } from '../types';

export const enum Language {
  EN = 'en',
  ES = 'es',
}

export type Entity = {
  id: number;
  name: string;
};

export type Tokens = {
  access: string;
  refresh: string;
  tfaValidated?: boolean;
};

export type PaginatedResponse<T> = {
  count: number;
  next?: string;
  previous?: string;
  results: T[];
};

export type PaginatedResponseDynamoDB<T> = {
  lastKey?: string;
  items: T[];
};

export type SignUpResponse = {
  id: number;
  name: string;
  email: string;
  country: string;
  contactPhone: string;
  companyName: string;
  companyTaxId: string;
  referralId: Nullable<string>;
  referralName: Nullable<string>;
};

export type Log = {};

export enum FeedbackStatus {
  RECEIVED = 'RECEIVED',
  REVIEWED = 'REVIEWED',
  RESOLVED = 'RESOLVED',
}

export type Feedback = {
  id: string;
  name?: string;
  email?: string;
  phone?: string;
  company: string;
  message: string;
  status: string;
  response?: string;
  created_at?: string;
  modified_at?: string;
};
